export default __webpack_public_path__ + "static/media/IMG-20220413-WA0023@2x.61d5df3d.png";